import { SetCommand } from 'logic/deviceScriptParser';
import { useTranslation } from 'react-i18next';

export type Props = {
    index: number;
    command: SetCommand;
    onChangeSetSetting(setting: string): void;
    onChangeSetValue(setting: string): void;
};

export const SetCommandOptions = ({ index, command, onChangeSetSetting, onChangeSetValue }: Props) => {
    const { t } = useTranslation();

    return (
        <span className="set-command-options">
            <input
                type="text"
                id={ `update-set-${index}-setting` }
                value={ command.setting }
                onChange={ e => onChangeSetSetting(e.target.value) }
                placeholder={ t('DEVICE.COMMANDS.SETTING_NAME') }
            />
            <input
                type="text"
                readOnly={ !command.setting }
                id={ `update-set-${index}-value` }
                value={ command.value }
                onChange={ e => onChangeSetValue(e.target.value) }
                placeholder={ t('DEVICE.COMMANDS.SETTING_VALUE') }
                style={ command.setting ? undefined : { opacity: .5 } }
            />
        </span>
    );
};
